import {OverlayOffset} from '@dropbox/dig-components/overlay';
import {Tooltip, TooltipProps} from '@dropbox/dig-components/tooltips';
import {useMobile} from 'hooks/isMobile';
import {CSSProperties, ReactNode, useRef, useState} from 'react';

// Helper component to optionally show a tooltip if title is specified
export const OptionalTooltip = ({
  enabled,
  openDelay,
  placement = 'top',
  auto,
  maxWidth,
  title,
  offsetDistance,
  wrapperClassName,
  wrapperStyle,
  children,
}: {
  enabled: boolean;
  openDelay?: number;
  placement?: TooltipProps['placement'];
  auto?: TooltipProps['auto'];
  maxWidth?: number;
  title?: ReactNode;
  offsetDistance?: OverlayOffset;
  wrapperClassName?: string;
  wrapperStyle?: CSSProperties;
  children: ReactNode;
}) => {
  const triggerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMobile();

  return enabled && title && !isMobile ? (
    <>
      <Tooltip.Control
        open={Boolean(enabled && isOpen)}
        triggerRef={triggerRef}
        placement={placement}
        auto={auto}
        openDelay={openDelay}
        maxWidth={maxWidth}
        offsetDistance={offsetDistance}
      >
        {title}
      </Tooltip.Control>
      <span
        ref={triggerRef}
        className={wrapperClassName}
        style={wrapperStyle}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        {children}
      </span>
    </>
  ) : (
    <>{children}</>
  );
};
